module.exports = __webpack_public_path__ + "img/Carte-apaym-06.21dd933b.png";